import ChatApp from './chat-app';
import r2wc from '@r2wc/react-to-web-component';

const chat = r2wc(ChatApp, { shadow: "open", props: ["pmcId", "propertyId", "environment"] });
if (!customElements.get('vivian-chat')) {
  customElements.define("vivian-chat", chat);
}